import { __exports as i } from "../../../_virtual/postal-code.js";
Object.defineProperty(i, "__esModule", { value: !0 });
i.postalCode = void 0;
var l = 3, n = new RegExp(/^[a-z0-9]+$/i);
function r(e, t) {
  return { isValid: e, isPotentiallyValid: t };
}
function o(e, t) {
  t === void 0 && (t = {});
  var a = t.minLength || l;
  return typeof e != "string" ? r(!1, !1) : e.length < a ? r(!1, !0) : n.test(e.trim().slice(0, a)) ? r(!0, !0) : r(!1, !0);
}
i.postalCode = o;
export {
  i as default
};
